import { useCallback, useState } from 'react'
import { Checkbox, Form, Input, Modal, ModalProps } from 'components/common'

export interface BookingDisapprovalModalProps extends Omit<ModalProps, 'onOk'> {
  onDisapprove: (reason: string) => void
  onClose: (value: boolean) => void
}

type DisapproveModalFormType = { reasonForDisapproval: string }

export const BookingDisapprovalModal = ({
  visible,
  onClose,
  onDisapprove,
}: BookingDisapprovalModalProps) => {
  const [form] = Form.useForm<DisapproveModalFormType>()
  const [disActive, setDisActive] = useState<boolean>(false)
  const handleClose = () => {
    onClose(false)
    setDisActive(true)
  }
  const onSubmit = useCallback(
    (values: DisapproveModalFormType) => {
      onDisapprove(values.reasonForDisapproval)
      onClose(false)
    },
    [onClose, onDisapprove]
  )

  return (
    <Modal
      title={'予約の非承認'}
      visible={visible}
      okText={'実行'}
      cancelText={'閉じる'}
      onOk={form.submit}
      onCancel={() => handleClose()}
    >
      <Form form={form} name="form_in_modal" onFinish={onSubmit}>
        <Checkbox checked={disActive} onChange={() => setDisActive(!disActive)}>
          非承認を実行する場合はチェックしてください
        </Checkbox>
        {disActive && (
          <div className="text-red-600 my-2">
            ※実行すると承認に変更できなくなります
          </div>
        )}
        <Form.Item
          name="reasonForDisapproval"
          rules={[
            {
              type: 'string',
              required: true,
              validateTrigger: 'onFinish',
              message: '理由の入力は必須です',
            },
            { type: 'string', max: 256, message: '最大256文字です' },
          ]}
        >
          <Input
            disabled={!disActive}
            placeholder="非承認の理由を入力してください"
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
